import { ReactNode } from 'react'

import { Corner } from './Corner'

interface ChatBubbleProps {
  children: ReactNode
  left?: boolean
  containerClassName?: string
}

export const ChatBubble = ({ children, left, containerClassName }: ChatBubbleProps) => {
  return (
    <div className={`relative w-full rounded-2xl bg-white p-4 drop-shadow-chat-bubble ${containerClassName}`}>
      {children}

      <Corner left={left} />
    </div>
  )
}
